export default "__VITE_ASSET__f67779b3__"